module.exports = __webpack_public_path__ + "img/8cf2c01.png";